import "./App.css";
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { Dashboard } from "./Pages/Dashboard/Dashboard";
import {
  Appointment,
  AppointmentDetailsedit,
  Appointmentedit,
  NewAppointment,
} from "./Pages/Appointment/Appointment";
import {
  AddPatientComponent,
  EditPatientlist,
  Listview,
  PatientEditComponent,
  PatientEditDetailsComponent,
  PatientRegistrationComponent,
} from "./Pages/Patient/Patient";
import { Loginpage, Loginpageforlogin } from "./Pages/Login/Loginpage";
import {
  AddBedComponent,
  AddBedGroupComponent,
  AddBedTypeComponent,
  AddFloorComponent,
  EditBedComponent,
  EditBedGroupComponent,
  EditBedTypeComponent,
  EditFloorComponent,
  ListViewBedComponent,
  ListViewBedGroupComponent,
  ListViewBedTypeComponent,
  ListViewFloorComponent,
} from "./Pages/Bed/Bed";
import {
  ChargesComponent,
  DetailChargesComponent,
  EditChargesComponent,
  NewChargesComponent,
} from "./Pages/Charges/Charges";
//import { HospitalComponent } from "./Pages/HospitalRegisrtation/HospitalComponent";
import {
  HospitalDetails,
  Hospitalistdetail,
  Hospitalists,
} from "./Hospital/HospitalDetails";
import {
  AddNewCharge,
  ChargesDetailsList,
} from "./Pages/AllCharges/AllCharges";
import {
  BillingListViewComponent,
  BillingPageComponent,
  CancelBillListComponent,
  EditBillingComponent,
} from "./Pages/Billing/Billing";
import ProtectedRoute from "./ProtectedRoute";
import PrivateRoute from "./PrivateRoute";
import {
  ListViewComponent,
  StaffEditComponent,
  StaffEditDetailsComponent,
  Staffreg,
} from "./Pages/Staff/Staff";
import {
  DischargedViewComponent,
  EditIPD,
  ListViewIPDComponent,
  OverViewComponent,
  PatientAdmitComponent,
} from "./Pages/IPDAppointment/IPD";
import { ReportAppointment, ReportBilling } from "./Pages/Reports/Reports";
import {
  AddBirthComponent,
  ListViewBirthComponent,
  UpdateBirthComponent,
} from "./Pages/Birth/Birth";
import {
  EditCategoryComponent,
  EditOperationComponent,
  ListViewCategoryComponent,
  ListViewOperationComponent,
  OperationCategoryComponent,
  OperationSetupComponent,
} from "./Pages/Operation/Operation";
import {
  AddMedicines,
  EditMedicineCategoryComponent,
  EditMedicineComponent,
  ListViewAddMedicines,
  ListViewMedicineChategory,
  MedicineChategory,
  AddMedicineUnitComponent,
  ListViewMedicineUnitComponent,
  EditMedicineUnitComponent,
  AddMedicineManufacturerComponent,
  ListViewMedicineManufacturerComponent,
  EditMedicineManufacturerComponent,
  ListViewMedicinesComponent,
  MedicineBillings,
  MedicineBillingList,
  PurchaseList,
  PurchaseMedicine,
  EditPurchaseComponent,
  EditPharmacyBillingDetails,
} from "./Pages/Medicine/Medicine";
import {
  AddRadiologyComponent,
  AddRadiologyUnits,
  EditRadiologyCategoryComponent,
  EditRadiologyParameter,
  EditRadiologyReportComponent,
  ListRadiologyReportComponent,
  ListViewAddRadiologyUnits,
  ListViewRadiologyChategories,
  ListViewRadiologyComponent,
  RadiologyChategory,
  RadiologyReportComponent,
} from "./Pages/Radiology/Radiology";
import {
  ListViewPathologyCategoryComponent,
  AddPathologyCategoryComponent,
  AddUnitComponent,
  ListViewUnitComponent,
  AddPathologyComponent,
  ListViewPathologyComponent,
  PathologyReportComponent,
  PathologyReportForm,
  EditPathologyReportComponent,
  EditPathologyCategory,
  EditPathologyUnit,
  EditPathologyParameter,
} from "./Pages/Pathology/Pathology";
import ListviewRadiologyParameter from "./Pages/Radiology/RadiologyPages/ListviewRadiologyParameter";
import AddRadiologyParameter from "./Pages/Radiology/RadiologyPages/AddRadiologyParameter";
import Landingpage from "./LandingPage/Landingpage";
import { ToastProvider } from "./Pages/ToastSystem";
import { ConfirmationProvider } from "./Pages/ConfirmationModal";
function App() {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isAuthRole, setIsAuthRole] = useState(false);
  const [isAuthRole1, setIsAuthRole1] = useState(false);
  const [isAuthRole2, setIsAuthRole2] = useState(false);
  const [isAuthRole3, setIsAuthRole3] = useState(false);

  console.log("+++++++++++++++++++++++++++++++++++++", isAuthRole1);
  const handleUpdateAuthorizationStatus = (authorizationStatus) => {
    setIsAuthorized(authorizationStatus);
  };
  const handleUpdateAuthorization = (authorization) => {
    setIsAuthRole(authorization);
  };

  const handleUpdateAuthorization1 = (authorization) => {
    setIsAuthRole1(authorization);
  };

  const handleUpdateAuthorization2 = (authorization) => {
    setIsAuthRole2(authorization);
  };

  const handleUpdateAuthorization3 = (authorization) => {
    setIsAuthRole3(authorization);
  };
  return (
    <ToastProvider>
      <ConfirmationProvider>
        <Router>
          <Switch>
            <Route
              path="/dashboard"
              exact
              component={(props) => (
                <ProtectedRoute {...props} component={Dashboard} />
              )}
            />

<PrivateRoute
  path="/appointment"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole || isAuthRole3) {
      return <Appointment />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/rescheduleappointment/:opdnumber"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={Appointmentedit} />
  )}
/>

<Route
  path="/editappointment/:opdnumber"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={AppointmentDetailsedit} />
  )}
/>

<PrivateRoute
  path="/newappointment"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <NewAppointment />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/addoperation"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <OperationSetupComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listviewoperations"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewOperationComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listviewcategories"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewCategoryComponent />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/editcategory/:categoryid"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditCategoryComponent} />
  )}
/>

<Route
  path="/editoperation/:operationsetupid"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditOperationComponent} />
  )}
/>

<PrivateRoute
  path="/addcategory"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <OperationCategoryComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/addbirth"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <AddBirthComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listviewbirth"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewBirthComponent />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/updatebirthrecord/:birthnumber"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={UpdateBirthComponent} />
  )}
/>

<Route
  path="/editbedgroup/:bedgroupid"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditBedGroupComponent} />
  )}
/>

<Route
  path="/editfloor/:floorid"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditFloorComponent} />
  )}
/>

<Route
  path="/editbed/:bedid"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditBedComponent} />
  )}
/>

<Route
  path="/editbedtype/:bedtypeid"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditBedTypeComponent} />
  )}
/>

<PrivateRoute
  path="/addbed"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <AddBedComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listviewfloor"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewFloorComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/addfloor"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <AddFloorComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/addbedgroup"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <AddBedGroupComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listviewbedgroup"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewBedGroupComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/addbedtype"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <AddBedTypeComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listviewbedtype"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewBedTypeComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listviewIPD"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole || isAuthRole3) {
      return <ListViewIPDComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/dischargedview"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <DischargedViewComponent />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/editipdpatientadmit/:admitnumber"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={OverViewComponent} />
  )}
/>

<PrivateRoute
  path="/patientadmit"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <PatientAdmitComponent />;
    } else {
      return;
    }
  }}
/>

<Route path="/" exact component={Landingpage} />

<Route path="/login" exact component={Loginpageforlogin} />
<PrivateRoute
  path="/userregistration"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <Staffreg />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/newpatientregistration"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <PatientRegistrationComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listviewbed"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewBedComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/allcharges"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ChargesComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/createcharges"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <NewChargesComponent />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/editcharges/:chargecode/edit"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditChargesComponent} />
  )}
/>

<Route
  path="/editcharges/:chargecode"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={DetailChargesComponent} />
  )}
/>

<PrivateRoute
  path="/listviewpatients"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <Listview />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/listviewpatients/:patientid"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={PatientEditComponent} />
  )}
/>

<Route
  path="/listviewpatients/:patientid/edit"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={PatientEditDetailsComponent}
    />
  )}
/>

<Route
  path="/hospital-list/:hospitalcode/edit"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={Hospitalistdetail} />
  )}
/>

<PrivateRoute
  path="/hospital-list"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized) {
      return <Hospitalists />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/hospital-registration"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized) {
      return <HospitalDetails />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/chargesdetailslist"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ChargesDetailsList />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/charges"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <AddNewCharge />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/billingpage"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <BillingPageComponent />;
    } else {
      return;
    }
  }}
/>
<PrivateRoute
  path="/billing"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <BillingListViewComponent />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/listviewstaff/:empid"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={StaffEditComponent} />
  )}
/>

<Route
  path="/listviewstaff/:empid/edit"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={StaffEditDetailsComponent}
    />
  )}
/>

<PrivateRoute
  path="/listviewstaff"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewComponent />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/editbilling/:billnumber"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditBillingComponent} />
  )}
></Route>

<PrivateRoute
  path="/appointmentreport"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ReportAppointment />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/billingreport"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ReportBilling />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/cancelbillinglist"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <CancelBillListComponent />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/addradiologycatagory"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={RadiologyChategory} />
  )}
></Route>

<Route
  path="/listrediologycatagory"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={ListViewRadiologyChategories}
    />
  )}
></Route>

<Route
  path="/addradiologyunit"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={AddRadiologyUnits} />
  )}
></Route>

<Route
  path="/listrediologyunit"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={ListViewAddRadiologyUnits}
    />
  )}
></Route>

<Route
  path="/addradiology"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={AddRadiologyComponent} />
  )}
/>

<PrivateRoute
  path="/editradiology/:billno/:radiologyreportid"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthRole2) {
      return <EditRadiologyReportComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/radiologyreport"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthRole2) {
      return <RadiologyReportComponent />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/radiologyreportlist"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={ListRadiologyReportComponent}
    />
  )}
/>
<Route
  path="/listviewradiology"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={ListViewRadiologyComponent}
    />
  )}
/>

<PrivateRoute
  path="/addmedicineunit"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <AddMedicineUnitComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listviewmedicineunit"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewMedicineUnitComponent />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/editmedicineunit/:medicineunitid"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={EditMedicineUnitComponent}
    />
  )}
/>

<PrivateRoute
  path="/addmedicinemanufacturer"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <AddMedicineManufacturerComponent />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listviewmedicinemanufacturer"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewMedicineManufacturerComponent />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/editmedicinemanufacturer/:medicinemanufacturerid"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={EditMedicineManufacturerComponent}
    />
  )}
/>

<PrivateRoute
  path="/addmedicinecatagory"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <MedicineChategory />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listmedicinecatagory"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewMedicineChategory />;
    } else {
      return;
    }
  }}
/>
<PrivateRoute
  path="/pharmacybilling"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <MedicineBillings />;
    } else {
      return;
    }
  }}
/>
<PrivateRoute
  path="/newpharmacypurchase"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <PurchaseMedicine />;
    } else {
      return;
    }
  }}
/>
<PrivateRoute
  path="/pharmacypurchase"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <PurchaseList />;
    } else {
      return;
    }
  }}
/>
<PrivateRoute
  path="/pharmacybillinglist"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <MedicineBillingList />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/addmedicine"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <AddMedicines />;
    } else {
      return;
    }
  }}
/>

<PrivateRoute
  path="/listmedicine"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthorized || isAuthRole) {
      return <ListViewMedicinesComponent />;
    } else {
      return;
    }
  }}
/>

<Route
  path="/editpurchase/:purchaseid"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditPurchaseComponent} />
  )}
></Route>
<Route
  path="/editpharmacybilling/:medicinebillingid"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={EditPharmacyBillingDetails}
    />
  )}
></Route>

<Route
  path="/addpathologycategory"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={AddPathologyCategoryComponent}
    />
  )}
/>

<Route
  path="/editmedicinecategory/:medicinecategoryid"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={EditMedicineCategoryComponent}
    />
  )}
/>

<Route
  path="/editmedicine/:medicineid"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditMedicineComponent} />
  )}
/>
<Route
  path="/listviewpathologycategory"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={ListViewPathologyCategoryComponent}
    />
  )}
/>

<Route
  path="/addunit"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={AddUnitComponent} />
  )}
/>

<Route
  path="/listviewunit"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={ListViewUnitComponent} />
  )}
/>

<Route
  path="/addpathology"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={AddPathologyComponent} />
  )}
/>

<Route
  path="/listviewpathology"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={ListViewPathologyComponent}
    />
  )}
/>

<Route
  path="/pathologyreport"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={PathologyReportComponent}
    />
  )}
/>

<Route
  path="/editpathology/:billingno"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={EditPathologyReportComponent}
    />
  )}
/>

<Route
  path="/editradiologycategory/:radiologycategoryid"
  exact
  component={(props) => (
    <ProtectedRoute
      {...props}
      component={EditRadiologyCategoryComponent}
    />
  )}
/>
<Route
  path="/editradiologyparameter/:radiologycode"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditRadiologyParameter} />
  )}
/>
<Route
  path="/editpathologycategory/:chargecode"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditPathologyCategory} />
  )}
/>
<Route
  path="/editpathologyunit/:unitid"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditPathologyUnit} />
  )}
/>
<Route
  path="/editpathologyparameter/:pathologycode"
  exact
  component={(props) => (
    <ProtectedRoute {...props} component={EditPathologyParameter} />
  )}
/>
<PrivateRoute
  path="/addpathologyreport"
  exact
  onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
  onUpdateAuthorization={handleUpdateAuthorization}
  onUpdateAuthorization1={handleUpdateAuthorization1}
  onUpdateAuthorization2={handleUpdateAuthorization2}
  onUpdateAuthorization3={handleUpdateAuthorization3}
  component={(props) => {
    // Check if the user is authorized and render Hospitalists or show Unauthorized Access
    console.log(props);
    if (isAuthRole1) {
      return <PathologyReportForm />;
    } else {
      return;
    }
  }}
/>

            <Route
              path="/unauthorized"
              component={() => <h1>Unauthorized Access!</h1>}
            />
            <Route
              path="*"
              component={() => <h1>Error 404 page not found !!</h1>}
            />
          </Switch>
        </Router>
      </ConfirmationProvider>
    </ToastProvider>
  );
}

export default App;

// import "./App.css";
// import React, { useState, useEffect } from "react";
// import {
//   BrowserRouter as Router,
//   Switch,
//   Route,
//   useLocation,
// } from "react-router-dom";
// import { Dashboard } from "./Pages/Dashboard/Dashboard";
// import {
//   Appointment,
//   AppointmentDetailsedit,
//   Appointmentedit,
//   NewAppointment,
// } from "./Pages/Appointment/Appointment";
// import {
//   AddPatientComponent,
//   EditPatientlist,
//   Listview,
//   PatientEditComponent,
//   PatientEditDetailsComponent,
//   PatientRegistrationComponent,
// } from "./Pages/Patient/Patient";
// import { Loginpage, Loginpageforlogin } from "./Pages/Login/Loginpage";
// import {
//   AddBedComponent,
//   AddBedGroupComponent,
//   AddBedTypeComponent,
//   AddFloorComponent,
//   EditBedComponent,
//   EditBedGroupComponent,
//   EditBedTypeComponent,
//   EditFloorComponent,
//   ListViewBedComponent,
//   ListViewBedGroupComponent,
//   ListViewBedTypeComponent,
//   ListViewFloorComponent,
// } from "./Pages/Bed/Bed";
// import {
//   ChargesComponent,
//   DetailChargesComponent,
//   EditChargesComponent,
//   NewChargesComponent,
// } from "./Pages/Charges/Charges";
// import {
//   HospitalDetails,
//   Hospitalistdetail,
//   Hospitalists,
// } from "./Hospital/HospitalDetails";
// import {
//   AddNewCharge,
//   ChargesDetailsList,
// } from "./Pages/AllCharges/AllCharges";
// import {
//   BillingListViewComponent,
//   BillingPageComponent,
//   CancelBillListComponent,
//   EditBillingComponent,
// } from "./Pages/Billing/Billing";
// import ProtectedRoute from "./ProtectedRoute";
// import PrivateRoute from "./PrivateRoute";
// import {
//   ListViewComponent,
//   StaffEditComponent,
//   StaffEditDetailsComponent,
//   Staffreg,
// } from "./Pages/Staff/Staff";
// import {
//   DischargedViewComponent,
//   EditIPD,
//   ListViewIPDComponent,
//   OverViewComponent,
//   PatientAdmitComponent,
// } from "./Pages/IPDAppointment/IPD";
// import { ReportAppointment, ReportBilling } from "./Pages/Reports/Reports";
// import {
//   AddBirthComponent,
//   ListViewBirthComponent,
//   UpdateBirthComponent,
// } from "./Pages/Birth/Birth";
// import {
//   EditCategoryComponent,
//   EditOperationComponent,
//   ListViewCategoryComponent,
//   ListViewOperationComponent,
//   OperationCategoryComponent,
//   OperationSetupComponent,
// } from "./Pages/Operation/Operation";
// import {
//   AddMedicines,
//   EditMedicineCategoryComponent,
//   EditMedicineComponent,
//   ListViewAddMedicines,
//   ListViewMedicineChategory,
//   MedicineChategory,
//   AddMedicineUnitComponent,
//   ListViewMedicineUnitComponent,
//   EditMedicineUnitComponent,
//   AddMedicineManufacturerComponent,
//   ListViewMedicineManufacturerComponent,
//   EditMedicineManufacturerComponent,
//   ListViewMedicinesComponent,
//   MedicineBillings,
//   MedicineBillingList,
//   PurchaseList,
//   PurchaseMedicine,
//   EditPurchaseComponent,
//   EditPharmacyBillingDetails,
// } from "./Pages/Medicine/Medicine";
// import {
//   AddRadiologyComponent,
//   AddRadiologyUnits,
//   EditRadiologyCategoryComponent,
//   EditRadiologyParameter,
//   EditRadiologyReportComponent,
//   ListRadiologyReportComponent,
//   ListViewAddRadiologyUnits,
//   ListViewRadiologyChategories,
//   ListViewRadiologyComponent,
//   RadiologyChategory,
//   RadiologyReportComponent,
// } from "./Pages/Radiology/Radiology";
// import {
//   ListViewPathologyCategoryComponent,
//   AddPathologyCategoryComponent,
//   AddUnitComponent,
//   ListViewUnitComponent,
//   AddPathologyComponent,
//   ListViewPathologyComponent,
//   PathologyReportComponent,
//   PathologyReportForm,
//   EditPathologyReportComponent,
//   EditPathologyCategory,
//   EditPathologyUnit,
//   EditPathologyParameter,
// } from "./Pages/Pathology/Pathology";
// import ListviewRadiologyParameter from "./Pages/Radiology/RadiologyPages/ListviewRadiologyParameter";
// import AddRadiologyParameter from "./Pages/Radiology/RadiologyPages/AddRadiologyParameter";
// import Landingpage from "./LandingPage/Landingpage";
// import { ToastProvider } from "./Pages/ToastSystem";
// import { ConfirmationProvider } from "./Pages/ConfirmationModal";
// import Header from "./Component/Header/Header";
// import Sidebar from "./Component/Sidebar";

// // Layout wrapper component
// const LayoutWrapper = ({ children }) => {
//   const location = useLocation();
//   const isAuthPage =
//     location.pathname === "/" || location.pathname === "/login";

//   return (
//     <>
//       {!isAuthPage && <Header />}
//       {!isAuthPage && <Sidebar />}
//       {children}
//     </>
//   );
// };

// function App() {
//   const [isAuthorized, setIsAuthorized] = useState(false);
//   const [isAuthRole, setIsAuthRole] = useState(false);
//   const [isAuthRole1, setIsAuthRole1] = useState(false);
//   const [isAuthRole2, setIsAuthRole2] = useState(false);
//   const [isAuthRole3, setIsAuthRole3] = useState(false);
//   const [isAuthRole4, setIsAuthRole4] = useState(false);

//   const handleUpdateAuthorizationStatus = (authorizationStatus) => {
//     setIsAuthorized(authorizationStatus);
//   };
//   const handleUpdateAuthorization = (authorization) => {
//     setIsAuthRole(authorization);
//   };
//   const handleUpdateAuthorization1 = (authorization) => {
//     setIsAuthRole1(authorization);
//   };
//   const handleUpdateAuthorization2 = (authorization) => {
//     setIsAuthRole2(authorization);
//   };
//   const handleUpdateAuthorization3 = (authorization) => {
//     setIsAuthRole3(authorization);
//   };
//   const handleUpdateAuthorization4 = (authorization) => {
//     setIsAuthRole4(authorization);
//   };

//   return (
//     <ToastProvider>
//       <ConfirmationProvider>
//         <Router>
//           <LayoutWrapper>
//             <Switch>
//               <Route path="/" exact component={Landingpage} />
//               <Route path="/login" exact component={Loginpageforlogin} />

//               <Route
//                 path="/dashboard"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={Dashboard} />
//                 )}
//               />

//               <PrivateRoute
//                 path="/appointment"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (
//                     isAuthorized ||
//                     isAuthRole ||
//                     isAuthRole3 ||
//                     isAuthRole4
//                   ) {
//                     return <Appointment />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/rescheduleappointment/:opdnumber"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={Appointmentedit} />
//                 )}
//               />

//               <Route
//                 path="/editappointment/:opdnumber"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={AppointmentDetailsedit}
//                   />
//                 )}
//               />

//               <PrivateRoute
//                 path="/newappointment"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <NewAppointment />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/addoperation"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <OperationSetupComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listviewoperations"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <ListViewOperationComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listviewcategories"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <ListViewCategoryComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/editcategory/:categoryid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditCategoryComponent}
//                   />
//                 )}
//               />

//               <Route
//                 path="/editoperation/:operationsetupid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditOperationComponent}
//                   />
//                 )}
//               />

//               <PrivateRoute
//                 path="/addcategory"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <OperationCategoryComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/addbirth"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <AddBirthComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listviewbirth"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <ListViewBirthComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/updatebirthrecord/:birthnumber"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={UpdateBirthComponent} />
//                 )}
//               />

//               <Route
//                 path="/editbedgroup/:bedgroupid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditBedGroupComponent}
//                   />
//                 )}
//               />

//               <Route
//                 path="/editfloor/:floorid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={EditFloorComponent} />
//                 )}
//               />

//               <Route
//                 path="/editbed/:bedid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={EditBedComponent} />
//                 )}
//               />

//               <Route
//                 path="/editbedtype/:bedtypeid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={EditBedTypeComponent} />
//                 )}
//               />

//               <PrivateRoute
//                 path="/addbed"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <AddBedComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listviewfloor"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <ListViewFloorComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/addfloor"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <AddFloorComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/addbedgroup"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <AddBedGroupComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listviewbedgroup"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <ListViewBedGroupComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/addbedtype"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <AddBedTypeComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listviewbedtype"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <ListViewBedTypeComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listviewIPD"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (
//                     isAuthorized ||
//                     isAuthRole ||
//                     isAuthRole3 ||
//                     isAuthRole4
//                   ) {
//                     return <ListViewIPDComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/dischargedview"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <DischargedViewComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/editipdpatientadmit/:admitnumber"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={OverViewComponent} />
//                 )}
//               />

//               <PrivateRoute
//                 path="/patientadmit"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <PatientAdmitComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route path="/" exact component={Landingpage} />

//               <Route path="/login" exact component={Loginpageforlogin} />
//               <PrivateRoute
//                 path="/userregistration"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <Staffreg />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/newpatientregistration"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <PatientRegistrationComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listviewbed"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <ListViewBedComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/allcharges"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <ChargesComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/createcharges"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <NewChargesComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/editcharges/:chargecode/edit"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={EditChargesComponent} />
//                 )}
//               />

//               <Route
//                 path="/editcharges/:chargecode"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={DetailChargesComponent}
//                   />
//                 )}
//               />

//               <PrivateRoute
//                 path="/listviewpatients"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <Listview />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/listviewpatients/:patientid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={PatientEditComponent} />
//                 )}
//               />

//               <Route
//                 path="/listviewpatients/:patientid/edit"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={PatientEditDetailsComponent}
//                   />
//                 )}
//               />

//               <Route
//                 path="/hospital-list/:hospitalcode/edit"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={Hospitalistdetail} />
//                 )}
//               />

//               <PrivateRoute
//                 path="/hospital-list"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized) {
//                     return <Hospitalists />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/hospital-registration"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized) {
//                     return <HospitalDetails />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/chargesdetailslist"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <ChargesDetailsList />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/charges"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <AddNewCharge />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/billingpage"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <BillingPageComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />
//               <PrivateRoute
//                 path="/billing"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <BillingListViewComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/listviewstaff/:empid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={StaffEditComponent} />
//                 )}
//               />

//               <Route
//                 path="/listviewstaff/:empid/edit"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={StaffEditDetailsComponent}
//                   />
//                 )}
//               />

//               <PrivateRoute
//                 path="/listviewstaff"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <ListViewComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/editbilling/:billnumber"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={EditBillingComponent} />
//                 )}
//               ></Route>

//               <PrivateRoute
//                 path="/appointmentreport"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <ReportAppointment />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/billingreport"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <ReportBilling />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/cancelbillinglist"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <CancelBillListComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/addradiologycatagory"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={RadiologyChategory} />
//                 )}
//               ></Route>

//               <Route
//                 path="/listrediologycatagory"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={ListViewRadiologyChategories}
//                   />
//                 )}
//               ></Route>

//               <Route
//                 path="/addradiologyunit"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={AddRadiologyUnits} />
//                 )}
//               ></Route>

//               <Route
//                 path="/listrediologyunit"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={ListViewAddRadiologyUnits}
//                   />
//                 )}
//               ></Route>

//               <Route
//                 path="/addradiology"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={AddRadiologyComponent}
//                   />
//                 )}
//               />

//               <PrivateRoute
//                 path="/editradiology/:billno/:radiologyreportid"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthRole2) {
//                     return <EditRadiologyReportComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/radiologyreport"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthRole2) {
//                     return <RadiologyReportComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/radiologyreportlist"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={ListRadiologyReportComponent}
//                   />
//                 )}
//               />
//               <Route
//                 path="/listviewradiology"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={ListViewRadiologyComponent}
//                   />
//                 )}
//               />

//               <PrivateRoute
//                 path="/addmedicineunit"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <AddMedicineUnitComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listviewmedicineunit"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <ListViewMedicineUnitComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/editmedicineunit/:medicineunitid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditMedicineUnitComponent}
//                   />
//                 )}
//               />

//               <PrivateRoute
//                 path="/addmedicinemanufacturer"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <AddMedicineManufacturerComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listviewmedicinemanufacturer"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole) {
//                     return <ListViewMedicineManufacturerComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/editmedicinemanufacturer/:medicinemanufacturerid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditMedicineManufacturerComponent}
//                   />
//                 )}
//               />

//               <PrivateRoute
//                 path="/addmedicinecatagory"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <MedicineChategory />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listmedicinecatagory"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <ListViewMedicineChategory />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />
//               <PrivateRoute
//                 path="/pharmacybilling"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <MedicineBillings />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />
//               <PrivateRoute
//                 path="/newpharmacypurchase"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <PurchaseMedicine />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />
//               <PrivateRoute
//                 path="/pharmacypurchase"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <PurchaseList />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />
//               <PrivateRoute
//                 path="/pharmacybillinglist"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <MedicineBillingList />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/addmedicine"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <AddMedicines />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <PrivateRoute
//                 path="/listmedicine"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 onUpdateAuthorization4={handleUpdateAuthorization4}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthorized || isAuthRole || isAuthRole4) {
//                     return <ListViewMedicinesComponent />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/editpurchase/:purchaseid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditPurchaseComponent}
//                   />
//                 )}
//               ></Route>
//               <Route
//                 path="/editpharmacybilling/:medicinebillingid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditPharmacyBillingDetails}
//                   />
//                 )}
//               ></Route>

//               <Route
//                 path="/addpathologycategory"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={AddPathologyCategoryComponent}
//                   />
//                 )}
//               />

//               <Route
//                 path="/editmedicinecategory/:medicinecategoryid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditMedicineCategoryComponent}
//                   />
//                 )}
//               />

//               <Route
//                 path="/editmedicine/:medicineid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditMedicineComponent}
//                   />
//                 )}
//               />
//               <Route
//                 path="/listviewpathologycategory"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={ListViewPathologyCategoryComponent}
//                   />
//                 )}
//               />

//               <Route
//                 path="/addunit"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={AddUnitComponent} />
//                 )}
//               />

//               <Route
//                 path="/listviewunit"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={ListViewUnitComponent}
//                   />
//                 )}
//               />

//               <Route
//                 path="/addpathology"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={AddPathologyComponent}
//                   />
//                 )}
//               />

//               <Route
//                 path="/listviewpathology"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={ListViewPathologyComponent}
//                   />
//                 )}
//               />

//               <Route
//                 path="/pathologyreport"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={PathologyReportComponent}
//                   />
//                 )}
//               />

//               <Route
//                 path="/editpathology/:billingno"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditPathologyReportComponent}
//                   />
//                 )}
//               />

//               <Route
//                 path="/editradiologycategory/:radiologycategoryid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditRadiologyCategoryComponent}
//                   />
//                 )}
//               />
//               <Route
//                 path="/editradiologyparameter/:radiologycode"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditRadiologyParameter}
//                   />
//                 )}
//               />
//               <Route
//                 path="/editpathologycategory/:chargecode"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditPathologyCategory}
//                   />
//                 )}
//               />
//               <Route
//                 path="/editpathologyunit/:unitid"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute {...props} component={EditPathologyUnit} />
//                 )}
//               />
//               <Route
//                 path="/editpathologyparameter/:pathologycode"
//                 exact
//                 component={(props) => (
//                   <ProtectedRoute
//                     {...props}
//                     component={EditPathologyParameter}
//                   />
//                 )}
//               />
//               <PrivateRoute
//                 path="/addpathologyreport"
//                 exact
//                 onUpdateAuthorizationStatus={handleUpdateAuthorizationStatus}
//                 onUpdateAuthorization={handleUpdateAuthorization}
//                 onUpdateAuthorization1={handleUpdateAuthorization1}
//                 onUpdateAuthorization2={handleUpdateAuthorization2}
//                 onUpdateAuthorization3={handleUpdateAuthorization3}
//                 component={(props) => {
//                   // Check if the user is authorized and render Hospitalists or show Unauthorized Access
//                   console.log(props);
//                   if (isAuthRole1) {
//                     return <PathologyReportForm />;
//                   } else {
//                     return;
//                   }
//                 }}
//               />

//               <Route
//                 path="/unauthorized"
//                 component={() => <h1>Unauthorized Access!</h1>}
//               />
//               <Route
//                 path="*"
//                 component={() => <h1>Error 404 page not found !!</h1>}
//               />
//             </Switch>
//           </LayoutWrapper>
//         </Router>
//       </ConfirmationProvider>
//     </ToastProvider>
//   );
// }

// export default App;
